"use strict";

require("../../style/index.less");

require("./index.less");

require("../../tabs/style");

require("../../row/style");

require("../../col/style");